import { Component, OnInit, TemplateRef, ViewChild  } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal} from '@ng\-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { BoardType } from 'src/app/core/models/board-type.model';
import { Board } from 'src/app/core/models/board.model';
import { BoardStats } from 'src/app/core/models/boardStats.model';
import { BvType } from 'src/app/core/models/bv-type.model';
import { CabinetType } from 'src/app/core/models/cabinet-type.model';
import { Cabinet } from 'src/app/core/models/cabinet.model';
import { Game } from 'src/app/core/models/game.model';
import { HarnessType } from 'src/app/core/models/harness-type.model copy';
import { Location } from 'src/app/core/models/location.model';
import { MonitorType } from 'src/app/core/models/monitor-type.model';
import { PrinterType } from 'src/app/core/models/printer-type.model';
import { RenewalMetric } from 'src/app/core/models/renewalMetric.model';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardTypeService } from 'src/app/core/services/board-type.service';
import { BoardService } from 'src/app/core/services/board.service';
import { BoardStatService } from 'src/app/core/services/boardstats.service';
import { BvTypeService } from 'src/app/core/services/bv-type.service';
import { CabinetTypeService } from 'src/app/core/services/cabinet-type.service';
import { CabinetService } from 'src/app/core/services/cabinet.service';
import { GameService } from 'src/app/core/services/game.service';
import { HarnessTypeService } from 'src/app/core/services/harness-type.service';
import { LocationService } from 'src/app/core/services/location.service';
import { LoginService } from 'src/app/core/services/login.service';
import { MonitorTypeService } from 'src/app/core/services/monitor-type.service.';
import { PrinterTypeService } from 'src/app/core/services/printer-type.service';
import { BoardStatsByIdComponent } from 'src/app/pages/boardStatsById/boardStatsById.component';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss']
})

// /**
//  * Dashboard Component
//  */
export class BoardComponent implements OnInit {
  readonly: boolean = false;
  term: string = '';
  filteredItems: any[] = [];
  salesRep: SalesRep[];
  locations: Location[];
  filteredLocations: Location[];
  games: Game[];
  filteredGames: Game[];
  boards: Board[];
  filteredBoards: Board[]
  boardTypes: BoardType[];
  renewalMetric: RenewalMetric;
  boardStats: BoardStats[];
  billValidatorType: BvType[];
  cabinetType: CabinetType[];
  monitorType: MonitorType[];
  harnessType: HarnessType[];
  printerType: PrinterType[];
  cabinets: Cabinet[];
  filteredCabinets: Cabinet[]
  searchCache = new Map<string, Board[]>();
  lastSearchTerm = '';
  private searchTexts: string[] = [];
  private searchDebounce: any;
  pageSize = 100;
  pageNumber = 0;
  hasMore = true;
  isLoadingPage = false;
  isImportingBoards = false;
  

  

  addEditMode: any;
  showAddCabinet = false;
  addEditFormGroup: FormGroup;
  addEditCabinetFormGroup: FormGroup;
  cabinetModalMode: string;
  

  renewalMetricTypes = [
    {key: RenewalMetric.DOLLARS, value: "Dollars"},
    {key: RenewalMetric.YEARS, value: "Years"},
    {key: RenewalMetric.DAYS, value: "Days"},
    {key: RenewalMetric.MONTHS, value: "Months"},
    {key: RenewalMetric.HOURS, value: "Hours"},
  ]
 
  constructor(
    private locationService: LocationService, private boardTypeService: BoardTypeService, private cabinetService: CabinetService,
    private boardService: BoardService, private gameService: GameService, private boardStatsService: BoardStatService,
    private bvTypeService: BvTypeService,  private harnessService: HarnessTypeService,
    private monitorTypeService: MonitorTypeService, private cabinetTypeService: CabinetTypeService, private printerTypeService: PrinterTypeService,
    private tastr: ToastrService, private modalService: NgbModal, private toastr: ToastrService,
    private loginService: LoginService, private router: Router
  ) {}

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Boards', active: true }];
    await this.refresh();
  }

  private isRestrictedSalesUser(): boolean {
    return this.loginService.userType === UserType.EXTERNAL || this.loginService.userType === UserType.CUSTOMER;
  }

  private belongsToCurrentSalesRep(board?: Board): boolean {
    if (!this.isRestrictedSalesUser()) {
      return true;
    }

    const loggedInId = (this.loginService.userId || '').replace(/-/g, '').toLowerCase();
    const repId = (board?.location?.salesRep?.id || '').replace(/-/g, '').toLowerCase();
    return !!repId && repId === loggedInId;
  }

async refresh() {
  try {
    this.readonly = this.isRestrictedSalesUser();

    const [games, boardTypes, locations] = await Promise.all([
      this.gameService.getAll(),
      this.boardTypeService.getAll(),
      this.locationService.getAll()
    ]);

    this.games = games;
    this.boardTypes = boardTypes;
    this.locations = this.isRestrictedSalesUser()
      ? (locations || []).filter((location) => {
          const loggedInId = (this.loginService.userId || '').replace(/-/g, '').toLowerCase();
          const repId = (location?.salesRep?.id || '').replace(/-/g, '').toLowerCase();
          return !!repId && repId === loggedInId;
        })
      : locations;
    this.boards = [];
    this.filteredBoards = [];
    this.pageNumber = 0;
    this.hasMore = true;

    await this.loadPage(true);
    this.updateFilteredLocations();
    this.updateFilteredGames();

    // Add displayName and bind value for ng-select
(this.games as any[]).forEach(game => {
  game.displayName = `${game.name} - ${game.version}`;
  game.combined = `${game.name} - ${game.version}`;
});

(this.locations as any[]).forEach(location => {
  location.displayName = `${location.locationTag} - ${location.locationName}`;
});


  } catch (error) {
    console.error('Error refreshing data:', error);
  }
}

  private async loadPage(reset: boolean = false): Promise<void> {
    if (this.isLoadingPage) return;
    this.isLoadingPage = true;
    const targetPage = reset ? 0 : this.pageNumber;

    try {
      const pageData = await this.boardService.getPage(targetPage, this.pageSize);
      if (reset) {
        this.boards = [];
        this.filteredBoards = [];
      }

      const visibleBoards = (pageData || []).filter((b) => this.belongsToCurrentSalesRep(b));
      this.boards = [...this.boards, ...visibleBoards.map(b => ({ ...b }))];
      this.buildSearchTexts(this.boards);

      const termLower = (this.term || '').trim().toLowerCase();
      if (termLower) {
        this.filteredBoards = this.boards.filter((_, idx) => this.searchTexts[idx]?.includes(termLower));
      } else {
        this.filteredBoards = [...this.boards];
      }

      this.hasMore = pageData.length === this.pageSize;
      this.pageNumber = targetPage + 1;
    } catch (err) {
      console.error('Failed to load boards page', err);
      this.hasMore = false;
    } finally {
      this.isLoadingPage = false;
    }
  }

  async loadNextPage(): Promise<void> {
    if (!this.hasMore || this.isLoadingPage) return;
    await this.loadPage(false);
  }


  onSearchChange(term: string) {
    this.term = term;
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    this.searchDebounce = setTimeout(() => {
      const termLower = (this.term || '').trim().toLowerCase();
      if (!termLower) {
        this.filteredBoards = [...this.boards];
        return;
      }
      this.filteredBoards = this.boards.filter((_, idx) => this.searchTexts[idx]?.includes(termLower));
    }, 120);
  }
  
  private boardMatchesSearch(board: Board, term: string): boolean {
    if (!term) return true; // If no search term, return all results
    
    term = term.toLowerCase().trim(); // Normalize search term
  
    const searchFields = [
      board.assetTag,
      board.serialNumber,
      board.boardType?.name,
      board.installedGamePackage?.name,
      board.installedGamePackage?.version,
      board.renewalQuota?.toString(),
      board.location?.salesRep?.firstName,
      board.location?.locationTag,
      board.location?.locationName,
    ].map(field => field?.toLowerCase().trim()); // Normalize all fields
  
    return searchFields.some(field => field?.includes(term));
  }
  
  

  // ... rest of the component code remains the same ...

  // openCabinetModal(modalTemplate: TemplateRef<any>, mode: string = 'Add') {
  //   this.addEditMode = mode;
  //   this.addEditCabinetFormGroup.reset(); // Reset form for a new cabinet
  
  //   const modalRef = this.modalService.open(modalTemplate); // Store the modal reference
    
  
  //   modalRef.result.then(async (result) => {
  //     if (result === 'Save click') {
  //       await this.saveCabinet(modalRef); // Pass the modal reference to saveCabinet
  //     }
  //   }).catch((error) => {
  //     console.error('Modal closed with error:', error);
  //   });
  // }
  
  // // Method to save cabinet and close the modal
  // async saveCabinet(modal: NgbModalRef) {
  //   const cabinetData = this.addEditCabinetFormGroup.value;
  //   if(cabinetData.boards.assetTag) {
  //     const assetTag = cabinetData.assetTag.split(" ")[0]
  //     delete cabinetData.locationTag;
  //     cabinetData.location = {assetTag}
  //   }
  //   if(cabinetData.locations.locationTag) {
  //     const locationTag = cabinetData.locationTag.split(" ")[0]
  //     delete cabinetData.locationTag;
  //     cabinetData.location = {locationTag}
  //   }
  
  //   try {
  //     const result = await this.cabinetService.create(cabinetData);
  //     if (result) {
  //       this.toastr.success('Cabinet created successfully');
  //       modal.close(); // Close the modal after successful creation
  //     }
  //   } catch (error) {
  //     this.toastr.error('Failed to create cabinet');
  //     console.error('Error creating cabinet:', error);
  //   }
  // }

  
  getBoardtStatsLink(item: BoardStats): String {
    return "";
  }

  showStats() {
    this.router.navigate(['/boardStats']);
  }

  showStatsForBoard(boardAssetTag) {
    this.router.navigate(['/boardStats', boardAssetTag]);
  }

  async onCheckBoxChanged(event: any, user: Board) {
    const newEnabledState = event?.target?.checked;
    
    if(user.enabled != newEnabledState) {
      await this.boardService.setEnabled(user.id, newEnabledState);
    }
  }
  async toggleFusionConnect(event: any, board: Board) {
    const newFusionConnectState = event.target.checked;
    try {
      // Update the backend first
      await this.boardService.setFusionConnect(board.id, newFusionConnectState);
      
      // Immediately reflect the change in the frontend state
      board.fusionConnect = newFusionConnectState; 
      console.log('Updated successfully:', board);
      
      // Optionally, re-fetch boards if needed to sync with backend
    } catch (error) {
      console.error('Update failed:', error);
    }
  }
  

  manageBoardTypes() {
    this.router.navigate(['/boardTypes']);
  }

  manageGames() {
    this.router.navigate(['/games'])
  }

  toggleCabPane(mode: string) {
    this.cabinetModalMode = mode;
    this.showAddCabinet = !this.showAddCabinet;
  }
  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.addEditFormGroup = new FormGroup({
      boardGroup: new FormGroup({
        id: new FormControl<string>(''),
        assetTag: new FormControl<string>(''),
        installDate: new FormControl<Date>(new Date()),
        removalDate: new FormControl<Date>(new Date()),
        serialNumber: new FormControl<string>(''),
        boardType: new FormControl<string>(''),
        installedGamePackage: new FormControl<string>(''),
        locationTag: new FormControl<string>(''),
        cabinetTag: new FormControl<string>(''),          
        renewalQuota: new FormControl<string>(''),
        renewalMetric: new FormControl<RenewalMetric>(RenewalMetric.DOLLARS),
        enabled: new FormControl<boolean>(true),
        notes: new FormControl<string>('')
      })
    });
    
    try {
      const results = await this.modalService.open(modal).result;
      if(results=="Save click") {
        try {
          const newBoardData = this.addEditFormGroup.value.boardGroup;
          // Keep existing data transformations
          if(newBoardData.assetTag) {
            if(newBoardData.assetTag.indexOf('/') != -1){
              throw new Error("Cannot contain illegal character /")
            }
            newBoardData.assetTag = newBoardData.assetTag.trim();
          }
          if(newBoardData.boardType) {newBoardData.boardType = {id: newBoardData.boardType}}
          if(newBoardData.installedGamePackage) {
            const splitPos = newBoardData.installedGamePackage.indexOf(' - ');
            const name = newBoardData.installedGamePackage.substr(0, splitPos);
            const version = newBoardData.installedGamePackage.substr(splitPos + 3);
            newBoardData.installedGamePackage = {name, version}
          }
          if(newBoardData.locationTag) {
            const locationTag = newBoardData.locationTag.split(" ")[0]
            delete newBoardData.locationTag;
            newBoardData.location = {locationTag}
          }
  
          const board = await this.boardService.create(newBoardData);
          if(board != null) {
            this.tastr.success('Board created successfully');
          } else {
            this.tastr.error('Failed to create board');
          }
        } catch(err) {
          console.error("Create errors", {status: err.status, err})
          switch(err.status){
            case 400:
              this.tastr.error('Bad request');
              break;
            default:
              this.tastr.error('Board not created');
          }
        }
      }
    } catch (error) {
      console.error('Modal error:', error);
    }
    await this.refresh();
  }

  async onBulkImportExcelChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];

    if (!file) {
      return;
    }

    if (this.isImportingBoards) {
      this.toastr.warning('A board import is already in progress.');
      input.value = '';
      return;
    }

    this.isImportingBoards = true;

    try {
      const rows = await this.readExcelRows(file);
      if (!rows.length) {
        this.toastr.warning('The selected file has no rows to import.');
        return;
      }

      const knownLocationTags = new Set(
        (this.locations || [])
          .map((l) => (l?.locationTag || '').toString().trim().toLowerCase())
          .filter(Boolean)
      );
      const allExistingBoards = await this.boardService.getAll();
      const existingAssetTags = new Set(
        (allExistingBoards || [])
          .map((b) => (b?.assetTag || '').toString().trim().toLowerCase())
          .filter(Boolean)
      );
      const existingSerialNumbers = new Set(
        (allExistingBoards || [])
          .map((b) => (b?.serialNumber || '').toString().trim().toLowerCase())
          .filter(Boolean)
      );
      const boardTypeIdByKey = new Map<string, string>(
        (this.boardTypes || [])
          .filter((bt) => !!bt?.id && !!bt?.name)
          .map((bt) => [this.normalizeHeader(bt.name), bt.id])
      );
      const gameByKey = new Map<string, Game>(
        (this.games || [])
          .filter((g) => !!g?.name && !!g?.version)
          .map((g) => [`${this.normalizeHeader(g.name)}|${this.normalizeHeader(g.version)}`, g])
      );

      const seenAssetTags = new Set<string>();
      const seenSerialNumbers = new Set<string>();
      let importedCount = 0;
      const errorMessages: string[] = [];

      for (let index = 0; index < rows.length; index++) {
        const row = rows[index] || {};
        const rowNumber = index + 2;

        const assetTag = this.getStringCell(row, ['asset tag', 'asset_tag', 'assettag']);
        const serialNumber = this.getStringCell(row, ['serial number', 'serial_number', 'serial', 'serialnumber']);
        const renewalQuotaText = this.getStringCell(row, ['renewal quota', 'renewal_quota', 'renewalquota', 'quota']);
        const renewalMetricText = this.getStringCell(row, ['renewal metric', 'renewal_metric', 'renewalmetric', 'metric']);
        const locationTag = this.getStringCell(row, ['location tag', 'location_tag', 'locationtag']);
        const boardTypeText = this.getStringCell(row, ['board type', 'board_type', 'boardtype']);

        let gameName = this.getStringCell(row, ['installed game', 'installed_game', 'installedgame', 'game name', 'gamename']);
        let gameVersion = this.getStringCell(row, ['installed game version', 'installed_game_version', 'installedgameversion', 'game version', 'gameversion', 'version']);
        const combinedGameText = this.getStringCell(row, ['installed game package', 'installed_game_package', 'installedgamepackage', 'game package', 'gamepackage', 'game']);

        if ((!gameName || !gameVersion) && combinedGameText && combinedGameText.includes(' - ')) {
          const splitPos = combinedGameText.indexOf(' - ');
          gameName = (gameName || combinedGameText.substring(0, splitPos)).trim();
          gameVersion = (gameVersion || combinedGameText.substring(splitPos + 3)).trim();
        }

        if (!assetTag || !serialNumber || !renewalQuotaText || !renewalMetricText || !locationTag || !boardTypeText || !gameName || !gameVersion) {
          errorMessages.push(`Row ${rowNumber}: missing one or more required fields.`);
          continue;
        }

        if (assetTag.includes('/')) {
          errorMessages.push(`Row ${rowNumber}: assetTag cannot contain '/'.`);
          continue;
        }

        const assetTagKey = assetTag.toLowerCase();
        if (seenAssetTags.has(assetTagKey)) {
          errorMessages.push(`Row ${rowNumber}: duplicate assetTag '${assetTag}' in file.`);
          continue;
        }
        if (existingAssetTags.has(assetTagKey)) {
          errorMessages.push(`Row ${rowNumber}: assetTag '${assetTag}' already exists in system.`);
          continue;
        }
        seenAssetTags.add(assetTagKey);

        const serialKey = serialNumber.toLowerCase();
        if (seenSerialNumbers.has(serialKey)) {
          errorMessages.push(`Row ${rowNumber}: duplicate serialNumber '${serialNumber}' in file.`);
          continue;
        }
        if (existingSerialNumbers.has(serialKey)) {
          errorMessages.push(`Row ${rowNumber}: serialNumber '${serialNumber}' already exists in system.`);
          continue;
        }
        seenSerialNumbers.add(serialKey);

        const parsedQuota = Number(renewalQuotaText);
        if (!Number.isFinite(parsedQuota)) {
          errorMessages.push(`Row ${rowNumber}: invalid renewalQuota '${renewalQuotaText}'.`);
          continue;
        }

        const normalizedMetric = this.normalizeRenewalMetric(renewalMetricText);
        if (!normalizedMetric) {
          errorMessages.push(`Row ${rowNumber}: invalid renewalMetric '${renewalMetricText}'.`);
          continue;
        }

        const locationTagKey = locationTag.toLowerCase();
        if (!knownLocationTags.has(locationTagKey)) {
          errorMessages.push(`Row ${rowNumber}: unknown locationTag '${locationTag}'.`);
          continue;
        }

        const boardTypeId = boardTypeIdByKey.get(this.normalizeHeader(boardTypeText));
        if (!boardTypeId) {
          errorMessages.push(`Row ${rowNumber}: unknown boardType '${boardTypeText}'.`);
          continue;
        }

        const matchedGame = gameByKey.get(
          `${this.normalizeHeader(gameName)}|${this.normalizeHeader(gameVersion)}`
        );
        if (!matchedGame) {
          errorMessages.push(`Row ${rowNumber}: unknown game '${gameName} - ${gameVersion}'.`);
          continue;
        }

        const payload: Partial<Board> = {
          assetTag,
          serialNumber,
          renewalQuota: parsedQuota,
          renewalMetric: normalizedMetric,
          enabled: true,
          location: { locationTag } as any,
          boardType: { id: boardTypeId } as any,
          installedGamePackage: { name: matchedGame.name, version: matchedGame.version } as any
        };

        try {
          await this.boardService.create(payload as Board);
          existingAssetTags.add(assetTagKey);
          existingSerialNumbers.add(serialKey);
          importedCount += 1;
        } catch (err: any) {
          const apiMessage = err?.error?.message || err?.message || 'failed to create board';
          errorMessages.push(`Row ${rowNumber}: ${apiMessage}`);
        }
      }

      if (importedCount > 0) {
        this.toastr.success(`Imported ${importedCount} board(s) successfully.`);
      }

      if (errorMessages.length > 0) {
        const preview = errorMessages.slice(0, 5).join(' | ');
        this.toastr.warning(
          `Import completed with ${errorMessages.length} issue(s). ${preview}`,
          'Board Import'
        );
        console.warn('Board import errors:', errorMessages);
      }

      if (importedCount > 0) {
        await this.refresh();
      }
    } catch (error: any) {
      console.error('Bulk board import failed:', error);
      this.toastr.error(error?.message || 'Failed to import boards from Excel file.');
    } finally {
      this.isImportingBoards = false;
      input.value = '';
    }
  }

  downloadBoardImportTemplate(): void {
    const templateRows = [
      {
        'Asset Tag': 'BOARD-1001',
        'Serial Number': 'SN-1001',
        'Renewal Quota': 100,
        'Renewal Metric': 'Dollars',
        'Location Tag': 'LOC-001',
        'Board Type': this.boardTypes?.[0]?.name || 'BoardTypeName',
        'Installed Game': this.games?.[0]?.name || 'GameName',
        'Installed Game Version': this.games?.[0]?.version || '1.0'
      }
    ];

    const worksheet = XLSX.utils.json_to_sheet(templateRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Board Import Template');
    XLSX.writeFile(workbook, 'board-import-template.xlsx');
  }

  private async readExcelRows(file: File): Promise<any[]> {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: 'array' });
    const sheetName = workbook.SheetNames[0];

    if (!sheetName) {
      return [];
    }

    const sheet = workbook.Sheets[sheetName];
    return XLSX.utils.sheet_to_json<any>(sheet, {
      defval: '',
      raw: false
    });
  }

  private getStringCell(row: any, aliases: string[]): string {
    const rowKeys = Object.keys(row || {});
    const keyMap = new Map<string, string>();

    for (const key of rowKeys) {
      keyMap.set(this.normalizeHeader(key), key);
    }

    for (const alias of aliases) {
      const normalizedAlias = this.normalizeHeader(alias);
      const foundKey = keyMap.get(normalizedAlias);
      if (!foundKey) {
        continue;
      }

      const value = row?.[foundKey];
      if (value === null || value === undefined) {
        return '';
      }

      return String(value).trim();
    }

    return '';
  }

  private normalizeHeader(value: string): string {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  private normalizeRenewalMetric(value: string): RenewalMetric | null {
    const normalized = this.normalizeHeader(value);
    switch (normalized) {
      case 'dollar':
      case 'dollars':
        return RenewalMetric.DOLLARS;
      case 'hour':
      case 'hours':
        return RenewalMetric.HOURS;
      case 'day':
      case 'days':
        return RenewalMetric.DAYS;
      case 'month':
      case 'months':
        return RenewalMetric.MONTHS;
      case 'year':
      case 'years':
        return RenewalMetric.YEARS;
      default:
        return null;
    }
  }

  async onChange() {
    console.log("onChange() called", this.addEditFormGroup.value)
  }

  async onDelete( id: string) {
    await this.boardService.delete(id);
    this.tastr.error('deleted');
    await this.refresh();     
  } 

  async showStatsByBoard( assetTag: string) {
    // await this.boardStatsService.getById(assetTag);
    // await this.refresh();
    this.router.navigate(['/boardStats/',assetTag]);
    }

  async downloadCsv() {
    const downloadResult = await this.boardService.download();
    const a = document.createElement('a');
    a.download = downloadResult.fileName;
    a.href = window.URL.createObjectURL(new Blob([downloadResult.file], {type: "text/csv"}));
    a.click();
    window.URL.revokeObjectURL(a.href);
    await this.refresh();
    this.tastr.error('downloaded');


    }
    async onEdit(modal: unknown, original: Board) {
      this.addEditMode = "Edit";
      this.showAddCabinet = false;
        // Format dates to YYYY-MM-DD format for input[type="date"]
      const formatDate = (date: any) => {
        if (!date) return null;
        const d = new Date(date);
        return d instanceof Date && !isNaN(d.getTime()) 
          ? d.toISOString().split('T')[0]
            : null;     
      };

      this.addEditFormGroup = new FormGroup({
        boardGroup: new FormGroup({
          id: new FormControl<string>(original.id),
          assetTag: new FormControl<string>(original.assetTag),
          installDate: new FormControl<string>(formatDate(original.installDate)),
          removalDate: new FormControl<string>(formatDate(original.removalDate)),
          serialNumber: new FormControl<string>(original.serialNumber),
          boardType: new FormControl<string>(original.boardType.id),
          installedGamePackage: new FormControl<string>(`${original.installedGamePackage.name} - ${original.installedGamePackage.version}`),
          renewalQuota: new FormControl<number>(original.renewalQuota),
          renewalMetric: new FormControl<RenewalMetric>(original.renewalMetric),
          cabinetTag: new FormControl<string>(original.cabinet ? `${original.cabinet.cabinetTag} - ${original.cabinet.cabinetType?.name}`: ''),
          enabled: new FormControl<boolean>(original.enabled),
          locationTag: new FormControl<string>(original.location.locationTag),
          notes: new FormControl<string>(original.notes || '')
        })
      });
    
      // cabinetGroup: new FormGroup({
      //   id: new FormControl<string>(''),
      //   cabinetTag: new FormControl<string>(''),
      //   purchased: new FormControl<string>(''),
      //   board: new FormControl<string>(''),
      //   cabinetType: new FormControl<string>(''),
      //   printerType: new FormControl<string>(''),
      //   harnessType: new FormControl<string>(''),
      //   monitorType: new FormControl<string>(''),
      //   billValidatorType: new FormControl<string>(''),
      //   location: new FormControl<string>(''),
      //   enabled: new FormControl<boolean>(true),
      // })
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
        // begin cabiet save here
        let cabinet = null;
        if(this.showAddCabinet) {
          const newCabinetData = this.addEditFormGroup.value.cabinetGroup;
          if (this.showAddCabinet) {
            const newCabinetData = this.addEditFormGroup.value.cabinetGroup;
            cabinet = { ...newCabinetData };
          } else if (original.cabinet) {
            cabinet = original.cabinet;
          }
        }

        const editBoardData = this.addEditFormGroup.value.boardGroup
        delete editBoardData.location;
        if(editBoardData.installedGamePackage) {
          const splitPos = editBoardData.installedGamePackage.indexOf(' - ');
          const name = editBoardData.installedGamePackage.substr(0, splitPos);
          const version = editBoardData.installedGamePackage.substr(splitPos + 3);;
          editBoardData.installedGamePackage = {name, version}
        }
        if(editBoardData.locationTag) {
          const locationTag = editBoardData.locationTag.split(" ")[0]
          delete editBoardData.locationTag;
          editBoardData.location = {locationTag}
        }
        if(editBoardData.cabinetTag) {
          editBoardData.cabinet = { cabinetTag: editBoardData.cabinetTag.split(" ")[0] };
          editBoardData.cabinetTag;
        } 
        if(editBoardData.boardType) {editBoardData.boardType = {id: editBoardData.boardType}}
        
        const board = await this.boardService.update(original.id, editBoardData);
        
        if(board != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  } 

  updateFilteredLocations(filter: any = null) {
    if(filter?.value){
      this.filteredLocations =  this.locations.filter(l => 
        (l.locationTag.toLowerCase().indexOf(filter.value.toLowerCase()) != -1) ||
        (l.locationName.toLowerCase().indexOf(filter.toLowerCase()) != -1))
    } else {
      this.filteredLocations =  this.locations;
    }
  }
  updateFilteredGames(filter: any = null) {
    if(filter?.value){
      this.filteredGames =  this.games.filter(g => g.name.toLowerCase().indexOf(filter.value.toLowerCase()) != -1);
    } else {
      this.filteredGames =  this.games;
    }
  }

  private buildSearchTexts(boards: Board[]): void {
    this.searchTexts = boards.map(board => {
      const parts = [
        board.assetTag,
        board.serialNumber,
        board.boardType?.name,
        board.installedGamePackage?.name,
        board.installedGamePackage?.version,
        board.renewalMetric,
        board.renewalQuota?.toString(),
        board.location?.salesRep?.firstName,
        board.location?.salesRep?.lastName,
        board.location?.locationTag,
        board.location?.locationName,
      ].filter(Boolean);
      return parts.join(' ').toLowerCase();
    });
  }
  updateFilteredBoards(filter: any = null) {
    if (!this.boards) {
      console.error("Error: `this.boards` is undefined.");
      this.filteredBoards = [];
      return;
    }

    if (filter) {
      const termLower = filter.toLowerCase().trim();
      this.filteredBoards = this.boards.filter((_, idx) => this.searchTexts[idx]?.includes(termLower));
    } else {
      this.filteredBoards = [...this.boards];
    }
  }

  updateFilteredCabinets(filter: any = null) {
    if (filter?.value) {
      // Filter cabinets that do not have a board and match the search term
      this.filteredCabinets = this.cabinets.filter(c => 
        !c.board && // Check if the cabinet has no board associated
        c.cabinetTag.toLowerCase().includes(filter.value.toLowerCase())
      );
    } else {
      // Filter all cabinets that do not have a board associated with them
      this.filteredCabinets = this.cabinets.filter(c => !c.board);
    }
    this.cabinets.forEach(cabinet => {
      console.log(cabinet.board); // Check if it's null, undefined, or actually contains a board object
    });
  
    // Log the output to debug
    console.log("Original Cabinets:", this.cabinets); 
    console.log("Filtered Cabinets:", this.filteredCabinets);
  }

      openBoardStatsModal(assetTag: string): void {
        const modalRef = this.modalService.open(BoardStatsByIdComponent, {
          size: 'lg', // or 'sm' depending on your design
        });
    
        modalRef.componentInstance.assetTag = assetTag;  // Pass the assetTag to the modal component
      }

  

  
  
}


